import { render, staticRenderFns } from "./score-content.vue?vue&type=template&id=ecff6ede&scoped=true&"
import script from "./score-content.vue?vue&type=script&lang=js&"
export * from "./score-content.vue?vue&type=script&lang=js&"
import style0 from "./score-content.vue?vue&type=style&index=0&id=ecff6ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecff6ede",
  null
  
)

export default component.exports